import * as docx from 'docx';
import {saveAs} from 'file-saver';
import * as docxFunc from './Docxhelper';
import {prepareCorrectionTableArray} from "../ControlStateHelper";
import {Paragraph} from "docx";
import { getDocxElementsFromString, draftjsToString } from "../WysiwygEditor/WysiwygHelpers"

export function generatePostControllInfoDocx(
    Props,
    infoData,
    checklistVersionInfo,
) {
    const generationTime = new Date(Date.now()).toLocaleString();
    const controlListApproved = infoData.isValidated;
    const emptyText = controlListApproved ? 'Brak.' : '';

      const tableBasicInfo = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Numer kontroli:', Props.number || emptyText),
            docxFunc.detailRow('Numer projektu:', Props.project.metadata.businessId || emptyText),
            docxFunc.detailRow('Tytuł projektu:', Props.project.title || emptyText),
        ],
    });

    const tableBeneficiaryInfo = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Identyfikator beneficjenta:', Props.project.beneficiaryIdentityNumber || emptyText),
            docxFunc.detailRow('Nazwa beneficjenta:', Props.project.beneficiaryName || emptyText),
            docxFunc.detailRow('Adres beneficjenta:', Props.project.beneficiaryAddress || emptyText),
        ],
    });

    const tableSubjectOfControlInfoTop = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Tryb kontroli:', Props.controlMode || emptyText),
            docxFunc.detailRow('Typ kontroli:', Props.controlType || emptyText),
            docxFunc.detailRow('Rodzaj kontroli:', Props.controlKind || emptyText),
            docxFunc.detailRow('Zespół kontrolujący:', Props.controlTeam || emptyText),
            docxFunc.detailRow('Zastosowana lista sprawdzająca:', Props.questionList.name || emptyText),
            docxFunc.detailRow('Wersja listy sprawdzającej:', controlListApproved ? (checklistVersionInfo || emptyText) : emptyText),
            docxFunc.detailRow('Planowany termin kontroli:', Props.plannedTerm || emptyText),
            docxFunc.detailRow('Data rozpoczęcia kontroli:', Props.term || emptyText),
            docxFunc.detailRow('Podmiot kontrolujący:', Props.controllingEntity || 'Brak podmiotu kontrolującego.'),
            docxFunc.detailRow('Podmioty kontrolowane:', Props.allControlledParties || 'Brak podmiotów kontrolowanych.'),
            docxFunc.detailRow('Miejsca przeprowadzenia kontroli:', Props.controlPlaces.length > 0 ? Props.controlPlaces.map(p => p.name).join("; ") : 'Brak miejsc przeprowadzenia kontroli.'),
            docxFunc.detailRow('Inne kontrolowane projekty:', Props.otherControlledProjectNumbers?.length > 0 ? Props.otherControlledProjectNumbers.join("; ") : 'Brak innych kontrolowanych projektów.'),
            docxFunc.detailRow('Kontrolowane zamówienia:', Props.orders.length === 0 ? 'Brak kontrolowanych zamówień.' : ''),
        ],
    });

    const tableSubjectOfControlInfoBottom = new docx.Table({
        columnWidths: [3505, 5505],
        rows: [
            docxFunc.detailRow('Numery kontrolowanych WoP:', Props.paymentClaims.length > 0 ? Props.paymentClaims.map(p => p.number).join(", ") : 'Brak kontrolowanych wniosków.'),
        ],
    });

    function infoDataAbbrevations(data) {
        if (!controlListApproved) return [];

        if (!data || data.length === 0) {
            return [
                new docx.Paragraph({
                    children: [docxFunc.text(emptyText, undefined, undefined, undefined, undefined)],
                })
            ];
        }

        const elements = getDocxElementsFromString(data);
        return elements;
    }

    function infoDataStringContent(data) {
        if (!controlListApproved) return [];

        let text = [];

        if (data === null || (data !== null && data.length === 0)) {
            text.push(docxFunc.text(emptyText));
        }

        const elements = getDocxElementsFromString(data);

        return elements;
    }

    const noAttachmentsParagraph = () => {
        return (
            new docx.Paragraph({
                children: [
                    docxFunc.text("Brak załączników.")
                ]
            })
        )
    }

    function attachments(attachments, attachmentsInDocument) {

        if(!controlListApproved) {
            return undefined;
        }

        if(attachments == null) {
            return noAttachmentsParagraph();
        }

        let attachmentsList = [];
        let attachmentsInDocumentArray = []
        
        attachmentsInDocument.map(attachment => {
            attachments.map(att => {
                if(attachment.documentId === att.id){
                    attachmentsInDocumentArray.push(att);
                }
            })
        })

        if (attachmentsInDocumentArray.length === 0) {
            return noAttachmentsParagraph();
        }

        const uniqueAttachments = attachmentsInDocumentArray.filter((obj, index) => {
            return index === attachmentsInDocumentArray.findIndex(o => obj.id === o.id);
        });

        uniqueAttachments.forEach((at, i) => {
            attachmentsList.push(docxFunc.text(`${++i}. ${at?.file?.fileName}`, undefined, true, undefined, i > 1));
        });
        
        return (
            new docx.Paragraph({
                children: attachmentsList,
            })
        )
    }

    function infoDataFindings(data) {
        if (!controlListApproved) return;

        let findings = data.sort(function (a, b) {
            return a.findingId - b.findingId;
        });
        let findingList = [];

        if (data) {
            if (findings.length === 0) {
                findingList.push(docxFunc.text(emptyText));
            } else {
                const blocksIds = findings.map(f => f.blockInList.id);
                const uniqueBlocksIds = blocksIds.filter((v, i, a) => a.indexOf(v) === i).sort(function (a, b) {
                    return a - b;
                });

                
                uniqueBlocksIds.forEach((block, blockIndex) => {
                    const findingsInBlock = findings.filter(f => f.blockInList.id === block);

                    const userFacingBlockIndex = blockIndex + 1;

                    let findingCounter = 0;

                    findingsInBlock.forEach((f, i) => {
                        const isNotLastItem = findingsInBlock.length > i + 1;
                        findingCounter++;

                        const addAdditionalSpace = findingCounter === 1 && userFacingBlockIndex !== 1;

                        if(addAdditionalSpace) {
                            findingList.push(docxFunc.text('', undefined, undefined, undefined , true));
                        }

                        findingList.push(docxFunc.text(`Ustalenie nr ${userFacingBlockIndex}.${findingCounter} ${f.blockInList?.name ? f.blockInList.name : ''}`, 26, false, true, addAdditionalSpace ? true : false, true));
                        
                        const findingTitle = draftjsToString(f.title).split("\n");

                        findingTitle.forEach((element) => {
                            findingList.push(docxFunc.text(element || emptyText, undefined, undefined, undefined , true));
                        });
                        
                        findingList.push(docxFunc.text('', undefined, undefined, undefined , true));
                        findingList.push(docxFunc.text('Ustalenie finansowe: ', 22, false, true, true));
                        findingList.push(docxFunc.text(f.isFinancial ? ' Tak' : ' Nie'));
                        if (f.isFinancial) {
                            findingList.push(docxFunc.text('', undefined, undefined, undefined , true));
                            findingList.push(docxFunc.text('Typ ustalenia finansowego: ', 22, false, true, true));
                            findingList.push(docxFunc.text(`${f.findingKind?.code} ${f.findingKind?.name}`));
                        }
                        findingList.push(docxFunc.text('', undefined, undefined, undefined , true));
                        findingList.push(docxFunc.text('Szczegóły ustalenia', 22, false, true, true));

                        const findingDetails = draftjsToString(f.content).split("\n");

                        findingDetails.forEach((element) => {
                            findingList.push(docxFunc.text(element || emptyText, undefined, undefined, undefined , true));
                        });

                        findingList.push(docxFunc.text('', undefined, undefined, undefined , true));
                        findingList.push(docxFunc.text(`Zalecenia związane z ustaleniem nr ${userFacingBlockIndex}.${findingCounter}: `, 22, false, true, true));
                        
                        if(f.recommendations.length > 0) {
                            f.recommendations.map((rec, recIndex) => {
                                findingList.push(docxFunc.text(`Zalecenie ${f.number}.${recIndex+1}`, undefined, false, true, true));
    
                                const recommendation = draftjsToString(rec.recommendationText)?.split("\n") ?? [];
    
                                recommendation.forEach((element) => {
                                    findingList.push(docxFunc.text(element, undefined, false, false, true));
                                });
                            })
                        } else {
                            findingList.push(docxFunc.text('Brak', undefined, undefined, undefined, undefined, undefined));
                        }

                        if (isNotLastItem) {
                            findingList.push(docxFunc.text(' ', undefined, undefined, undefined, true));
                            findingList.push(docxFunc.text('', undefined, undefined, undefined, true));
                        }
                    })
                })
            }
        }
        return (
            new docx.Paragraph({
                children: findingList,
                spacing: findings.length === 0 ? undefined : {before: 180, lineRule: docx.LineRuleType.AUTO},
            })
        )
    }

    function correctionTable(data, orders) {
        if (!controlListApproved) return [];

        if(data.length <= 0 || !data.some(x => x.isFinancial)) {
            return [
                new docx.Paragraph({
                    children: [
                        docxFunc.text("Brak ustaleń finansowych.", undefined, undefined, undefined, undefined, undefined)
                    ]
                })
            ]
        }

        let sum = 0;
        [910, 910, 1820, 910, 910, 910, 910, 910, 910].forEach(v => { sum = sum + v });

        const corrections = prepareCorrectionTableArray(data, orders);

        if (corrections.length > 0) {
            const table = docxFunc.correctionTable(
                [
                    "L.p.",
                    "Numer ustalenia",
                    "Typ ustalenia",
                    "Korekta kosztów pośrednich",
                    "Rodzaj korekty",
                    "Stawka korekty",
                    "Podstawa korekty",
                    "Kwota wydatków niekwalifikowalnych",
                    "Projekt",
                    "Wniosek o płatność",
                    "Zamówienia publiczne"
                ],
                corrections,
                row => docxFunc.tableRow([
                    row.lp,
                    row.findingNumber,
                    row.findingKind,
                    row.indirectCostsDisplay,
                    row.kind,
                    row.rateFormatted,
                    row.baseFormatted,
                    row.wrongExpenditureFormatted,
                    row.projectNumber,
                    row.number,
                    row.orderNumber,
                ]));

            const elements = [table];

            if (infoData?.financialFindingsNotes) {
                elements.push(docxFunc.brakeLine(10));
                elements.push(new docx.Paragraph({
                    children: [
                        docxFunc.text('Uwagi do ustaleń finansowych:', 22, false, true, false)
                    ]
                }));
                const financialFindingsNotesList = [];
                const financialFindingsNotes = draftjsToString(infoData.financialFindingsNotes)?.split("\n") ?? [];
                financialFindingsNotes.forEach((element) => {
                    financialFindingsNotesList.push(docxFunc.text(element, undefined, false, false, true));
                });
                elements.push(new docx.Paragraph({
                    children: financialFindingsNotesList
                }));
            }

            return elements;
        }
        return [new Paragraph("")];
    }

    const doc = new docx.Document({
        sections: [{
            properties: {
            },
            headers: {
                default: new docx.Header({
                    children: [
                        docxFunc.pageHeader(Props.number),
                        docxFunc.pageHeader('Utworzono ' + generationTime),
                    ],
                }),
            },
            children: [
                docxFunc.draft(controlListApproved),
                docxFunc.brakeLine(20, true),
                docxFunc.header(`${infoData?.isFinalInfo ? 'OSTATECZNA ' : ''}INFORMACJA POKONTROLNA`),
                docxFunc.header(`${Props.number}-${infoData?.isFinalInfo ? 'OST' : 'INF'}`),
                docxFunc.brakeLine(20),
                docxFunc.brakeLine(20),
                docxFunc.blockTitle('Informacje wstępne'),
                docxFunc.subTitleWithLines('Informacje o projekcie'),
                tableBasicInfo,
                docxFunc.brakeLine(1),
                docxFunc.subTitleWithLines('Dane beneficjenta ', -1),
                tableBeneficiaryInfo,
                docxFunc.brakeLine(1),
                docxFunc.subTitleWithLines('Informacje o kontroli'),
                tableSubjectOfControlInfoTop,
                ...docxFunc.ordersTable([["Numer ogłoszenia o zamówieniu", "Nazwa zamówienia", "Kontrakty"], ...Props.orders?.map((order) => [order.orderNumber, order.orderName, docxFunc.formatContractsValue(order.contracts)])]),
                tableSubjectOfControlInfoBottom,
                docxFunc.subTitle('1. Wykaz skrótów'),
                ...infoDataAbbrevations(infoData?.abbreviations),
                docxFunc.subTitle('2. Podstawa prawna', 360, 80),     
                ...infoDataStringContent(infoData?.legalBasis),
                docxFunc.subTitle('3. Cel kontroli', 350, 70),
                ...infoDataStringContent(infoData?.controlPurpose),
                docxFunc.subTitle('4. Przedmiot kontroli', 360, 70),
                ...infoDataStringContent(infoData?.controlSubject),
                docxFunc.subTitle('5. Ustalenia i zalecenia pokontrolne', 360, 80),
                infoDataFindings(infoData?.findings),
                docxFunc.subTitle('6. Podsumowanie ustaleń finansowych', 360, 80),
                ...correctionTable(infoData?.findings || [], Props.orders),
                docxFunc.subTitle('7. Podsumowanie kontroli', 360, 80),
                ...infoDataStringContent(infoData?.controlSummary),
                docxFunc.subTitle('8. Pouczenia końcowe', 360, 80),
                ...infoDataStringContent(infoData?.finalInstructions),
                docxFunc.subTitle('9. Załączniki', 360, 80),
                attachments(Props?.documents, infoData?.attachments)
            ],
            footers: {
                default: new docx.Footer({
                    children: [
                        new docx.Paragraph({
                            alignment: docx.AlignmentType.CENTER,
                            children: [
                                new docx.TextRun({
                                    children: [
                                        "Strona: ",
                                        docx.PageNumber.CURRENT,
                                        " z ",
                                        docx.PageNumber.TOTAL_PAGES
                                    ],
                                    size: 16,
                                    font: 'Calibri',
                                    color: '#616161'
                                }),

                            ],
                        }),
                    ],
                }),
            },
        }],
    });

    docx.Packer.toBlob(doc).then((blob) => {
        const mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        const docblob = blob.slice(0, blob.size, mimeType);
        saveAs(docblob, `${Props.number}${infoData?.isFinalInfo ? '_OST' : '_INF'}.docx`)
    });
}
